/* eslint-disable no-underscore-dangle */
import { createStandaloneToast } from '@chakra-ui/react';
import { ENV } from '@shared/config/env';
import axios from 'axios';

import { clearCookies } from './clearCookies';
const { toast } = createStandaloneToast();

export const apiNexpro = axios.create({
  baseURL: ENV.VITE_API_URL_NEXPRO,
  headers: {
    'Content-Type': 'application/json',
  },
});

const urlsToIgnore401 = ['/user/get-user-info', '/oauth/token'];

apiNexpro.interceptors.response.use(
  response => response,
  async error => {
    if (urlsToIgnore401.includes(error.config.url)) return;

    if (error.response.status === 401) {
      setTimeout(() => {
        apiNexpro.defaults.headers.Authorization = '';
        clearCookies();
        sessionStorage.clear();
        window.location.reload();
        window.location.href = ENV.VITE_FRONT_URL_NEXPRO;
      }, 1500);
    }

    toast({
      title: 'Erro',
      description: error.response.data.friendlyMessage,
      status: 'error',
      position: 'top-right',
    });
    throw error;
  },
);
